import { useNavigate } from 'react-router-dom';

interface NearbyToolsProps {
  locationName: string;
  nearbyCities: Array<{name: string, slug: string, path: string, distance?: string}>;
}

const NearbyTools = ({ locationName, nearbyCities }: NearbyToolsProps) => {
  const navigate = useNavigate();

  if (nearbyCities.length === 0) return null;

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-2">
          Salary Calculators Near {locationName}
        </h2>
        <p className="text-gray-600 mb-8">
          Compare tax rates and take-home pay in nearby locations
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {nearbyCities.map((city, index) => (
            <div
              key={index}
              onClick={() => navigate(city.path)}
              className="group bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 rounded-xl p-6 hover:border-blue-500 hover:shadow-lg transition-all cursor-pointer transform hover:-translate-y-1"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-blue-100 rounded-lg group-hover:bg-blue-500 transition-colors">
                  <i className="ri-map-pin-line text-xl text-blue-600 group-hover:text-white"></i>
                </div>
                {city.distance && (
                  <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full whitespace-nowrap">
                    {city.distance}
                  </span>
                )}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                {city.name}
              </h3>
              <div className="flex items-center text-blue-600 text-sm font-medium group-hover:translate-x-1 transition-transform">
                Calculate <i className="ri-arrow-right-line ml-1"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NearbyTools;